module.exports = __webpack_public_path__ + "static/img/XS-1.7b72fb3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/vubrostand/XS-1/XS-1.png
// module id = JZ9Z
// module chunks = 0